module.exports = __webpack_public_path__ + "img/JAOC_POP_SquidInkSauce_oval.369b0bf1.png";